// ============================================
// useTranslation Hook
// ============================================

import { useState, useEffect, useCallback } from 'react';
import { t as translate, getLanguage, setLanguage as setLang, Language, initializeLanguage } from './index';

export function useTranslation() {
  const [language, setLanguageState] = useState<Language>(getLanguage);
  
  // Initialize on mount
  useEffect(() => {
    initializeLanguage();
  }, []);
  
  // Listen for language changes
  useEffect(() => {
    const handleLanguageChange = (e: CustomEvent<Language>) => {
      setLanguageState(e.detail);
    };
    
    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => window.removeEventListener('languageChange', handleLanguageChange as EventListener);
  }, []);
  
  const t = useCallback((key: string) => translate(key, language), [language]);
  
  const setLanguage = useCallback((lang: Language) => {
    setLang(lang);
    setLanguageState(lang);
  }, []);
  
  const isRTL = language === 'ar';
  
  return { t, language, setLanguage, isRTL };
}

export type { Language };
